import {
  ChangeDetectorRef,
  Directive,
  EmbeddedViewRef,
  inject,
  input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Permission, UserPermissionsService } from '../services';

@Directive({
  selector: '[hasPerm]',
})
export class PermissionsDirective implements OnInit {
  hasPerm = input.required<Permission | Permission[]>();

  templateView?: EmbeddedViewRef<unknown>;

  private readonly changeDetector = inject(ChangeDetectorRef);
  private readonly permissionService = inject(UserPermissionsService);
  private readonly templateRef = inject(TemplateRef<unknown>);
  private readonly viewContainer = inject(ViewContainerRef);

  ngOnInit() {
    this.update();
  }

  async update() {
    this.viewContainer.clear();

    if (this.permissionService.hasPermission(this.hasPerm())) {
      this.templateView = this.viewContainer.createEmbeddedView(this.templateRef);

      this.changeDetector.markForCheck();
    }
  }
}
